<template>
  <div>
    <!-- featured Carousel -->
    <section
      v-if="relatedProduct.length > 0"
      class="product_slider big_container modify-slider product-recommanded--slider"
    >
      <h2 class="card_heading product_slider_heading" v-html="shopifyData.secHeading" />

      <swiper
        :modules="modules"
        :breakpoints="swiperOptions.breakpoints"
        :space-between="10"
        :speed="1200"
        :loop="relatedProduct.length > 6"
        navigation
      >
        <!-- product Card -->
        <template v-if="shopifyData.showProduct === 'true'">
          <swiper-slide v-for="(value, key) in relatedProduct" :key="key" class="product_item">
            <!-- this block work for single product products -->
            <div v-if="value.hasOwnProperty('single')" class="card product-recommanded-card">
              <a
                :href="`/products/` + value.single.handle"
                :aria-label="value.single.title + ' Product Link'"
              >
                <div
                  :id="`item_left_` + value.single.handle"
                  class="item_left"
                  :class="{
                    item_left_active: value.single.variants[0].inStock < 5,
                  }"
                >
                  {{
                    value.single.variants[0].inStock <= 5 && value.single.variants[0].inStock >= 1
                      ? 'ONLY ' + value.single.variants[0].inStock + ' LEFT'
                      : value.single.variants[0].inStock == 0
                        ? 'SOLD OUT'
                        : ''
                  }}
                </div>
                <!-- 
                <div v-if="value.single.images.length > 1" :class="'has-hover'" class="product_img_wrapper product-recommanded_img_has-hover">
                  <img v-lazy="value.single.featured_image" :alt="value.single.featured_image.alt" class="normal" />
                  <img v-lazy="value.single.images[1]" alt="" class="hoverImg" />
                </div> -->

                <!-- Case 1 — 2+ Images (normal + hover) -->
                <div
                  v-if="value.single.images.length > 1"
                  :class="'has-hover'"
                  class="product_img_wrapper product-recommanded_img_has-hover"
                >
                  <!-- NORMAL IMAGE -->
                  <picture class="normal">
                    <source
                      :srcset="`${value.single.featured_image}?width=400&format=webp 400w`"
                      type="image/webp"
                    />
                    <source
                      :srcset="`${value.single.featured_image}?width=400 400w`"
                      type="image/jpeg"
                    />
                    <img
                      v-lazy="value.single.featured_image + '?width=400'"
                      :alt="
                        value.single.featured_image.alt || value.single.title + ' Product Image'
                      "
                      :aria-label="
                        value.single.featured_image.alt || value.single.title + ' Product Image'
                      "
                      loading="lazy"
                      decoding="async"
                      class="normal"
                      sizes="400px"
                      style="aspect-ratio: 1/1"
                    />
                  </picture>

                  <!-- HOVER IMAGE -->
                  <picture>
                    <source
                      :srcset="`${value.single.images[1]}?width=400&format=webp 400w`"
                      type="image/webp"
                    />
                    <source
                      :srcset="`${value.single.images[1]}?width=400 400w`"
                      type="image/jpeg"
                    />
                    <img
                      :src="value.single.images[1] + '?width=400'"
                      :alt="
                        value.single.images[1].alt || value.single.title + ' Hover Product Image'
                      "
                      :aria-label="
                        value.single.images[1].alt || value.single.title + ' Hover Product Image'
                      "
                      loading="lazy"
                      decoding="async"
                      class="hoverImg"
                      sizes="400px"
                      aspect-ration="1/1"
                    />
                  </picture>
                </div>

                <!-- Case 2 — Only 1 Image -->
                <!-- <div v-else-if="value.single.images.length == 1"  :class="'single-img'" class="product_img_wrapper product-recommanded_single_img">
                  <img v-lazy="value.single.featured_image" alt="" class="normal" />
                </div> -->
                <div
                  v-else-if="value.single.images.length == 1"
                  :class="'single-img'"
                  class="product_img_wrapper product-recommanded_single_img"
                >
                  <picture class="normal">
                    <source
                      :srcset="`${value.single.featured_image}?width=400&format=webp 400w`"
                      type="image/webp"
                    />
                    <source
                      :srcset="`${value.single.featured_image}?width=400 400w`"
                      type="image/jpeg"
                    />
                    <img
                      v-lazy="value.single.featured_image + '?width=400'"
                      :alt="
                        value.single.featured_image.alt || value.single.title + ' Product Image'
                      "
                      :aria-label="
                        value.single.featured_image.alt || value.single.title + ' Product Image'
                      "
                      loading="lazy"
                      decoding="async"
                      class="normal"
                      sizes="400px"
                    />
                  </picture>
                </div>

                <!-- Case 3 — No Image (same) -->
                <div
                  v-else
                  class="product_img_wrapper product-recommanded_no-img"
                  :class="'no-img'"
                >
                  <img
                    src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                    alt="placeholder"
                    aria-label="Placeholder Product Image"
                    loading="lazy"
                    decoding="async"
                    class="normal"
                  />
                </div>

                <div class="card-title product_title">
                  {{ cleanTitle(value.single.title) }}
                </div>
                <div class="card-title bold product_price">
                  <span
                    v-if="value.single.price && value.single.compare_at_price"
                    class="tmb_product_price"
                  >
                    <span>
                      <del>
                        {{ currencySymbol }}
                        {{ formatPrice(value.single.compare_at_price / 100) }}
                      </del>
                    </span>
                    <span class="tmb_discounted">
                      {{ currencySymbol }}
                      {{ formatPrice(value.single.price / 100) }}
                    </span>
                    <span class="discount-percentage">
                      {{
                        Math.round(
                          ((value.single.compare_at_price - value.single.price) /
                            value.single.compare_at_price) *
                            100
                        )
                      }}% off
                    </span>
                  </span>
                  <span v-else>
                    {{ currencySymbol }}
                    {{ formatPrice(value.single.price / 100) }}
                  </span>
                </div>
              </a>

              <div class="quickButton quickActive">
                <div class="color_swatches" />
                <div class="product_cta_wrapper" data-v-32bfb114="">
                  <span v-if="value.single.variants[0].inStock != 0">
                    <button
                      :id="'quickAdd' + value.single.id"
                      class="quickAdd"
                      type="button"
                      aria-label="Quick Add"
                      :variantid="value.single.variants[0].id"
                      @click="addToCard"
                    >
                      <span>Add</span>
                      <div class="loader_tmb">
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                      </div>
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <!-- this block work for single product products -->

            <div
              v-if="value.hasOwnProperty('variable') && value.variable.length - 1 >= value.active"
              class="card"
            >
              <a
                :href="`/products/` + value.variable[value.active].handle"
                :aria-label="value.variable[value.active].title + ' Product Link'"
              >
                <div
                  :id="`item_left_` + value.variable[value.active].handle"
                  class="item_left"
                  :class="{
                    item_left_active: value.variable[value.active].variants[0].inStock < 5,
                  }"
                >
                  {{
                    value.variable[value.active].variants[0].inStock <= 5 &&
                    value.variable[value.active].variants[0].inStock >= 1
                      ? 'ONLY ' + value.variable[value.active].variants[0].inStock + ' LEFT'
                      : value.variable[value.active].variants[0].inStock == 0
                        ? 'SOLD OUT'
                        : ''
                  }}
                </div>

                <div
                  v-if="value.variable[value.active].images.length > 2"
                  id="product_img_wrapper6617090588769"
                  class="product_img_wrapper"
                >
                  <!-- <img v-lazy="value.variable[value.active].featured_image" alt="" class="normal" />
                  <img v-lazy="value.variable[value.active].images[1]" alt="" class="hoverImg" /> -->

                  <!-- NORMAL IMAGE for single product products -->
                  <picture class="normal">
                    <source
                      :srcset="`${value.variable[value.active].featured_image}?width=400&format=webp 400w`"
                      type="image/webp"
                    />
                    <source
                      :srcset="`${value.variable[value.active].featured_image}?width=400 400w`"
                      type="image/jpeg"
                    />
                    <img
                      :src="value.variable[value.active].featured_image + '?width=400'"
                      :alt="value.variable[value.active].featured_image || 'Product Image'"
                      :aria-label="
                        value.variable[value.active].featured_image ||
                        value.variable[value.active].title + ' Product Image'
                      "
                      loading="lazy"
                      decoding="async"
                      class="normal"
                      sizes="400px"
                    />
                  </picture>

                  <!-- HOVER IMAGE for single product products -->
                  <picture>
                    <source
                      :srcset="`${value.variable[value.active].images[1]}?width=400&format=webp 400w`"
                      type="image/webp"
                    />
                    <source
                      :srcset="`${value.variable[value.active].images[1]}?width=400 400w`"
                      type="image/jpeg"
                    />
                    <img
                      :src="value.variable[value.active].images[1] + '?width=400'"
                      :alt="value.variable[value.active].images[1].alt || 'Product Image'"
                      :aria-label="
                        value.variable[value.active].images[1].alt ||
                        value.variable[value.active].title + ' Hover Product Image'
                      "
                      loading="lazy"
                      decoding="async"
                      class="hoverImg"
                      sizes="400px"
                    />
                  </picture>
                </div>
                <div
                  v-else-if="value.variable[value.active].images.length == 1"
                  id="product_img_wrapper6617090588769"
                  class="product_img_wrapper"
                >
                  <!-- <img v-lazy="value.variable[value.active].featured_image" alt="" class="normal" /> -->

                  <picture class="normal">
                    <source
                      :srcset="`${value.variable[value.active].featured_image}?width=400&format=webp 400w`"
                      type="image/webp"
                    />
                    <source
                      :srcset="`${value.variable[value.active].featured_image}?width=400 400w`"
                      type="image/jpeg"
                    />
                    <img
                      v-lazy="value.variable[value.active].featured_image + '?width=400'"
                      :alt="value.variable[value.active].featured_image || 'Product Image'"
                      :aria-label="
                        value.variable[value.active].featured_image ||
                        value.variable[value.active].title + ' Product Image'
                      "
                      loading="lazy"
                      width=""
                      height=""
                      decoding="async"
                      class="normal"
                      sizes="400px"
                    />
                  </picture>
                </div>
                <div v-else class="product_img_wrapper">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                    alt="placeholder image"
                    loading="lazy"
                    aria-label="Placeholder Product Image"
                    width=""
                    height=""
                    class="normal"
                  />
                </div>

                <div class="card-title product_title">
                  {{ cleanTitle(value.variable[value.active].title) }}
                </div>
                <div class="card-title bold product_price">
                  <span
                    v-if="
                      value.variable[value.active].price &&
                      value.variable[value.active].compare_at_price
                    "
                    class="tmb_product_price"
                  >
                    <span>
                      <del>
                        {{ currencySymbol }}
                        {{ formatPrice(value.variable[value.active].compare_at_price / 100) }}
                      </del>
                    </span>
                    <span class="tmb_discounted">
                      {{ currencySymbol }}
                      {{ formatPrice(value.variable[value.active].price / 100) }}
                    </span>
                    <span class="discount-percentage">
                      {{
                        Math.round(
                          ((value.variable[value.active].compare_at_price -
                            value.variable[value.active].price) /
                            value.variable[value.active].compare_at_price) *
                            100
                        )
                      }}% off
                    </span>
                  </span>
                  <span v-else>
                    {{ currencySymbol }}{{ formatPrice(value.variable[value.active].price / 100) }}
                  </span>
                </div>
              </a>
              <div class="quickButton quickActive">
                <!-- <div
                  class="color_swatches"
                  :class="[value.swatches.length <= 4 ? 'not-slider':'tmbSlider']"
                >
                  <swiper
                    :main-key="JSON.stringify(value)"
                    class="swatches_inner mySwiper"
                    :slides-per-view="'auto'"
                    :space-between="7"
                    :navigation="true"
                    :modules="modules"
                  >
                    <swiper-slide
                      v-for="(sValue, sKey) in value.swatches"
                      :key="sKey"
                      :index="sKey"
                      :link="sValue.link"
                      class="nav-dots"
                      :class="sKey == value.active ? 'active' : ''"
                      :active-index="sKey == value.active ? 'true' : 'false'"
                      @click="selectVariation"
                    >
                      <span>
                        <img
                          v-lazy="getThemeAssets(sValue.img)"
                          :class="sValue.img"
                        >
                      </span>
                    </swiper-slide>
                  </swiper>

              
                </div> -->
                <div class="product_cta_wrapper" data-v-32bfb114="">
                  <button
                    :id="'quickAdd' + value.variable[value.active].id"
                    :class="{
                      quickAdd_deactive: value.variable[value.active].variants[0].inStock == 0,
                    }"
                    :variantid="value.variable[value.active].variants[0].id"
                    qty="1"
                    type="button"
                    class="quickAdd"
                    aria-label="Quick Add"
                    @click="addToCard"
                  >
                    <span>Add</span>
                    <div class="loader_tmb">
                      <span />
                      <span />
                      <span />
                      <span />
                      <span />
                    </div>
                  </button>
                </div>

                <!-- <div
                  class="product_cta_wrapper"
                  data-v-32bfb114=""
                >
                  <button
                    :id="'quickAdd' + value.variable[value.active].id"
                    :class="{ quickAdd_deactive: value.variable[value.active].variants[0].inStock == 0 }"
                    :variantid="value.variable[value.active].variants[0].id"
                    qty="1"
                    class="quickAdd"
                    aria-label="Quick Add"
                    @click="addToCard"
                  >
                    <span>Quick Add</span>
                    <div class="loader_tmb"> 
                      <span /><span />
                      <span /><span />
                      <span />
                    </div>
                  </button>
                </div> -->
              </div>
            </div>
          </swiper-slide>
        </template>
        <!-- Custom card -->
      </swiper>
    </section>
    <section v-if="relatedProduct.length == 0" class="product_slider big_container modify-slider">
      <h2 class="card_heading product_slider_heading" v-html="shopifyData.secHeading" />
      <p>No Related Product Here</p>
    </section>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Mousewheel, Autoplay } from 'swiper';
import { currencyJson } from '@/currency';

import 'swiper/css';
import { ShopifyAPI } from '@/vue/Shopify/Shopify';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Mousewheel, Autoplay],
    };
  },
  data() {
    return {
      relatedProduct: [],
      relatedProductWithTag: [],
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
      swiperOptions: {
        breakpoints: {
          300: {
            slidesPerView: 2,
            slidesPerGroup: 1,
          },
          575: {
            slidesPerView: 3,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 5,
            slidesPerGroup: 1,
          },
          1440: {
            slidesPerView: 6,
            slidesPerGroup: 1,
          },
        },
      },
    };
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;

    this.relatedProducts();
    window.addEventListener('load', () => {
      const tmbSliderCtaNext = document.querySelectorAll('.tmbSlider .swiper-button-next');
      const tmbSliderCtaPrev = document.querySelectorAll('.tmbSlider .swiper-button-prev');
      // next button Click
      for (const i of tmbSliderCtaNext) {
        i.addEventListener('click', () => {
          i.closest('.tmbSlider')?.classList.add('removeMargin');
        });
      }
      // prev Button click
      for (const i of tmbSliderCtaPrev) {
        i.addEventListener('click', () => {
          if (i.matches('.swiper-button-disabled')) {
            i.closest('.tmbSlider')?.classList.remove('removeMargin');
          }
        });
      }
    });
  },
  methods: {
    formatPrice(value) {
      return value.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    cleanTitle(str) {
      if (!str) return '';
      return str
        .normalize('NFC') // encoding normalize
        .replaceAll('Â°', '°') // common Shopify encoding fix
        .replaceAll('Â', ''); // extra broken byte cleanup
    },

    async addToCard(event) {
      // document.querySelector('.bg_layer_removecart').classList.add('active');

      event.target.closest('.card').classList.add('active');
      let product;
      if (event.target.tagName === 'SPAN') {
        product = event.target.parentNode;
      } else {
        product = event.target;
      }

      const variant = product.getAttribute('variantid');
      const dynamic = new ShopifyAPI();

      const item = {
        id: variant,
        qty: 1,
      };
      await dynamic.addItem(item);
      event.target.closest('.card').classList.remove('active');
    },

    getThemeAssets(image) {
      let assets = window.atob(this.shopifyData.swatchesImages);
      assets = JSON.parse(assets);

      let src = '';
      for (const images in assets) {
        if (Object.keys(assets[images])[0] == image) {
          src = Object.values(assets[images])[0];
        }
      }
      return src;
    },

    async relatedProducts() {
      /// fetch shopify graphQl queries

      const productData = window.atob(this.shopifyData.collectionListing);
      const Products = JSON.parse(productData);

      let currentProductTag = window.atob(this.shopifyData.productTag);
      currentProductTag = JSON.parse(currentProductTag);

      let filterListing = [];
      const duplicateRecord = [];

      const Categories = currentProductTag;

      for (const product in Products) {
        // Products.map(async (e, i) => {
        // product type

        // console.log(e)
        const p = Products[product][0]; /// product object
        const v = Products[product][1]; /// variant object
        const stock = Products[product][2]; /// variant object

        const handle = p.handle;

        /*********************************************************/
        /// category filter applied here (start)
        /*********************************************************/
        if (Categories.length > 0) {
          // first check if value set
          let catFlag = false;

          Categories.map((selectedTags) => {
            if (p.tags.includes(selectedTags)) {
              catFlag = true;
            }
          });

          if (catFlag == false) continue;
        }

        /*********************************************************/
        /// category filter applied here (end)
        /*********************************************************/

        /// filter variants check links exist
        let links = ''; /// product pair links
        for (const varints in v) {
          if ('testing_product_variants' == varints || 'testing_product_swatchs' == varints) {
            links = v['testing_product_variants'];
          }
        }

        const bindInPair = []; // product bind in same pair
        let flag = false; // flag for single product

        if (links.includes('/')) {
          links = links.split(' ');
          // console.log(links);

          if ('object' == typeof links) {
            // console.log(links)
            for (const lnk in links) {
              if (links[lnk].replace('/products/', '') == handle) {
                //
              } else {
                bindInPair.push(links[lnk].replace('/products/', ''));
                duplicateRecord.push(links[lnk].replace('/products/', ''));
              }
            }
          }
        } else {
          flag = true;
        }

        const productType = {}; // check product type is single or variation

        if (bindInPair.length > 0) {
          /*********************************************************/
          /// filter variable product
          /*********************************************************/
          const swatch = await this.getSwatch(v);
          const collectPairProducts = [];

          /*********************************************/
          // default load code for variable products
          /*********************************************/

          let variableActiveIndex = 0;
          for (const swatchPl in swatch) {
            const Phandle2 = swatch[swatchPl].link;

            for (const childPair in Products) {
              //  // console.log(products[childPair].node.handle,'===', Phandle)
              if (Products[childPair][0].handle == Phandle2.replace('/products/', '')) {
                if (handle == Products[childPair][0].handle) {
                  variableActiveIndex = swatchPl;
                }
                // console.log(Products[childPair][0]);
                // append stock qty
                Products[childPair][0].variants = this.appendStock(
                  Products[childPair][0].variants,
                  Products[childPair][2]
                );
                collectPairProducts.push(Products[childPair][0]);
              }
            }
          }

          // console.log(variableActiveIndex)

          productType['variable'] = collectPairProducts;
          productType['swatches'] = swatch;
          productType['active'] = variableActiveIndex;

          filterListing.push(productType);

          /*********************************************************/
          /// filter variable product (END)
          /*********************************************************/
        } else if (bindInPair.length == 0) {
          /*********************************************************/
          /// filter apply at single products
          /*********************************************************/
          p.variants = this.appendStock(p.variants, stock);
          productType['single'] = p;
          filterListing.push(productType);

          /*********************************************************/
          /// filter single product (END)
          /*********************************************************/
        } else if (flag) {
          // else condition will be work if product have no variation
          // filterListing.push(p);
        }
      }

      filterListing = this.shuffle(filterListing);

      this.relatedProduct = [...filterListing].slice(0, 100);
    },

    /**
     *  getSwatch filter the json for each product also verify product has variation
     */
    async getSwatch(metaFields) {
      // get pair links
      let links = '';
      let swatchs = '';
      const swatchLIST = [];

      for (const meta in metaFields) {
        const key = meta;

        if (key == 'testing_product_variants') {
          links = metaFields[meta].split(' ');
        }
        if (key == 'testing_product_swatchs') {
          swatchs = metaFields[meta].split(' ');
        }
      }

      // console.log(assets.assets)

      // collection variation if exist
      if (links.length !== 0 && swatchs.length !== 0) {
        //  conbine to link and swatchs

        for (const img in swatchs) {
          const imgLoop = img;
          for (const link in links) {
            if (link == imgLoop) {
              const repeatEl = {};
              repeatEl.img = swatchs[imgLoop];

              repeatEl.link = links[link];
              swatchLIST.push(repeatEl);
            } else {
              continue;
            }
          }
        }
      }

      // activeHandle

      if (swatchLIST.length !== 0) {
        return swatchLIST;
      }

      return false;

      // /**
      //  *  if nothing variation found above loop then return false (It's mean's product have no variation)
      // */
      // return false;
    },
    appendStock(variants, stocks) {
      const newVariants = [];
      variants.map((appendStock) => {
        const V_id = appendStock.id;
        for (const stok in stocks) {
          if (stok == V_id) {
            const newVar = appendStock;
            newVar.inStock = stocks[stok];
            newVariants.push(newVar);
          }
        }
      });
      return newVariants;
    },
    shuffle(array) {
      let currentIndex = array.length,
        randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
      }

      return array;
    },

    selectVariation: (event) => {
      /**
       * targeted element id
       */
      const target = event.target;

      const grid =
        target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;

      const children = target.parentNode.parentNode.parentNode.children;
      for (let i = 0; i < children.length; i++) {
        children[i].setAttribute('activeindex', 'false');
      }

      // add active call to current active element
      target.parentNode.parentNode.setAttribute('activeindex', 'true');

      // get active index

      const index = target.parentNode.parentNode.getAttribute('index');

      const productsData = JSON.parse(
        target.parentNode.parentNode.parentNode.parentNode.getAttribute('main-key')
      );

      // active product
      const activeProduct = productsData.variable[index];
      // update product data

      // change title

      // grid.querySelector(".product_title").innerHTML = activeProduct.title;
      // grid.querySelector(".product_price").innerHTML =
      //   "$ " + (activeProduct.price / 100).toFixed(2);

      /// update link of the grid
      grid.getElementsByTagName('a')[0].setAttribute('href', '/products/' + activeProduct.handle);

      // chnage images of the grid
      grid
        .querySelector('img.normal')
        .setAttribute(
          'src',
          activeProduct.images[0] == null
            ? 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'
            : activeProduct.images[0]
        );

      grid
        .querySelector('img.hoverImg')
        .setAttribute(
          'src',
          activeProduct.images.length > 2
            ? activeProduct.images[1]
            : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'
        );

      // chnage quick button content
      // console.log(activeProduct)

      // grid
      //     .querySelector("button")
      //     .setAttribute("variantid", activeProduct.variants[0].id);

      // if (activeProduct.variants[0].inStock == 0) {
      //     grid.querySelector("button").classList.add("quickAdd_deactive");
      // } else {
      //     grid.querySelector("button").classList.remove("quickAdd_deactive");
      // }

      // check how many product are left in product inventory

      if (activeProduct.variants[0].inStock == 0) {
        grid.querySelector('.item_left').classList.add('item_left_active');
        grid.querySelector('.item_left').innerHTML = 'SOLD OUT';
      } else if (activeProduct.totalInventory < 5) {
        grid.querySelector('.item_left').classList.add('item_left_active');
        grid.querySelector('.item_left').innerHTML =
          'Only ' + activeProduct.variants[0].inStock + ' Left';
      } else {
        grid.querySelector('.item_left').classList.remove('item_left_active');
      }
    },
  },
};
</script>

<style scoped>
.discount-percentage {
  color: red;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: 700;
}

.tmb_product_price {
  display: flex;
  align-items: center;
  gap: 8px;
}
.color_swatches {
  position: relative;
  max-width: 142px;
  width: 100%;
  overflow: hidden;
  padding: 0 20px;
}
.color_swatches.not-slider {
  padding: 0;
}
.swiper-slide.nav-dots {
  border-radius: 50%;
}
.swiper-wrapper {
  transition-timing-function: ease;
}
.swiper-slide.nav-dots img {
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
  display: block;
  max-height: 20px;
}
.nav-dots[activeindex='true'] {
  border: 2px solid rgba(0, 0, 0, 0.6);
}
.color_swatches.tmbSlider {
  margin-left: -15px;
  transition: 0.4s;
}
.color_swatches.tmbSlider.removeMargin {
  margin-left: 0;
}
/* .nav-dots.active {
    border: 2px solid rgba(0, 0, 0, 0.6);
} */
/* featured carousel */
.product_slider {
  padding: 26px 0 60px;
}

.product_slider_heading {
  margin: 0px 0 8px 15px;
}

.product_slider .swiper-slide {
  max-width: 397px;
}

.product_slider .swiper {
  padding-left: 15px;
  padding-bottom: 15px;
}
.color_swatches .swiper {
  padding-left: 0;
  padding-bottom: 0;
}

.color_swatches ul {
  display: flex;
  gap: 7px;
}

.color_swatches ul li {
  position: relative;
  line-height: 0;
}

li.nav-dots:after {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  outline: 1px solid #ccc;
  content: '';
  border-radius: 50%;
  left: 0;
}

li.nav-dots.active:after {
  outline: 2px solid rgba(0, 0, 0, 0.6);
}

.color_swatches ul li img {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.color_swatches ul li:hover {
  cursor: pointer;
}

.card-title {
  font-size: 14px;
  text-align: left;
}

.card .card-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  margin-top: 6px;
}

.card-title.bold {
  font-weight: 700;
}

.card {
  border: none;
  position: relative;
}

.card .item_left {
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 1;
  opacity: 0;
  transition: 0.2s;
}
.card:hover .item_left {
  opacity: 1;
}

.card > img {
  width: 100%;
  height: 100%;
}

.product_img_wrapper .hoverImg {
  position: absolute;
  left: 0;
  visibility: hidden;
  opacity: 0;
  top: 0;
  transition: opacity 0.25s ease;
}

.product_img_wrapper {
  position: relative;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.product_img_wrapper img {
  width: 100%;

  object-fit: cover;
}

.product_item:hover .quickActive,
.product_img_wrapper:hover .hoverImg {
  opacity: 1;
  visibility: visible;
}

.product_item:empty {
  display: none;
}

.quickButton {
  justify-content: space-between;
  display: flex;
  opacity: 0;
  visibility: hidden;
  align-items: center;
  transition: 0.3s;
  padding: 8px 0px;
}

.quickAdd {
  border: 1px solid #000;
  padding: 8px 30px;
  background: #ffffff;
  gap: 15px;
  flex-direction: row;
  align-items: flex-start;
  transition: 0.3s;
  display: none;
}

.quickButton .quickAdd:hover {
  background: #000;
}

.quickButton .quickAdd:hover span {
  color: #fff;
}

.quickAdd_deactive {
  visibility: hidden;
}

.quickAdd_active {
  visibility: visible;
}

.quickAdd span {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.discount-percentage {
  margin: 0;
}

@media only screen and (max-width: 991px) {
  .product_slider .swiper {
    padding-left: 0px;
  }
  .tmb_product_price {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 768px) {
  .product_slider {
    padding: 10px 0 50px;
  }

  .card-title {
    font-size: 12px;
    margin: 10px 0 0;
  }
}

@media only screen and (max-width: 767px) {
  .quickButton {
    opacity: 1;
    visibility: visible;
  }
  .product-recommanded--slider .swiper-button-prev,
  .product-recommanded--slider .swiper-button-next {
    display: block;
  }
}

@media only screen and (max-width: 480px) {
  .product_slider .swiper-slide {
    max-width: 70%;
  }
}

@media only screen and (max-width: 575px) {
  .card .item_left {
    top: 5px;
    right: 5px;
  }
}
</style>
